import React, { Component } from 'react';
import clazz from 'classnames';
import styles from './index.less';
import { Dropdown, Menu, Icon } from 'antd';
class RightContent extends Component {
    render() {
        const { className, style, sso } = this.props;
        if (sso.isLogin === 'unknown')
            return null;
        const logoutNode = (<Menu>
        <Menu.Item>
          <a href={`//${process.env.MUJI_APP_SSO_HOST}/logout.htm`} target="_blank" rel="noopener noreferrer">
            退出登录
          </a>
        </Menu.Item>
      </Menu>);
        return (<div className={clazz(className, styles.rightContent)} style={style}>
        {sso.isLogin ? (<Dropdown overlay={logoutNode} placement="bottomCenter">
            <span style={{ display: 'inline-block', height: 48 }}>
              {sso.userInfo && sso.userInfo.displayName}
              <Icon type="down"/>
            </span>
          </Dropdown>) : (<a href={`//${process.env.MUJI_APP_SSO_HOST}/login.htm`} target="_blank">
            尚未登录
          </a>)}
      </div>);
    }
}
export default RightContent;
